import { gql } from '@apollo/client';

export default gql`
  {
    Voices{
        IdVoz
        Voz
    }
  }
`;